import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { S25CheckboxComponent } from "./s25.checkbox.component";
import { TypeManagerDecorator } from "../../main/type.map.service";

@TypeManagerDecorator("s25-ng-shift-selectable-checkbox")
@Component({
    selector: "s25-ng-shift-selectable-checkbox",
    template: `
        <s25-ng-checkbox
            s25-ng-shift-selectable
            [shiftSelectIndex]="index"
            [shiftSelectGroup]="group"
            [(value)]="value"
            [(successMessage)]="successMessage"
            [onChange]="onChange()"
            [disabled]="disabled()"
            [containerClass]="containerClass()"
            [labelId]="labelId()"
            [labelClass]="labelClass()"
            [ariaLabel]="ariaLabel()"
            [noLabel]="noLabel()"
        >
            <ng-content></ng-content>
        </s25-ng-checkbox>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25ShiftSelectableCheckboxComponent extends S25CheckboxComponent {
    @Input() index: number;
    @Input() group: string;
}
